import { IContent } from '@/@types/cms';

export const isContentType = (content: IContent, type: string) =>
  content?.contentType?.slice(-1)[0] === type;

export const isOfContentType = (content: IContent, matchingTypes: string[]) =>
  matchingTypes.includes(content.contentType?.slice(-1)[0] ?? '');
